exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labels-grid__header-cell {\n  min-width: 200px; }\n\n.labels-grid__cell--modified {\n  background: rgba(157, 215, 216, 0.35); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap!./src/components/pages/pages/search/labelsGrid/LabelsGridCell.scss
// module id = 1376
// module chunks = 0